<template>
  <div class="tableballbox">
    <div
      v-for="(item, infoIndex) in list"
      :key="`table-ball-box-${period}-${infoIndex}`"
      class="tableballbox__item"
    >
      <div
        class="ball size-middle"
        :class="[item.ball[currentLabel].className, { 'image-disable': item.isOpacity }]"
      >
        <span
          v-show="item.ball[currentLabel].showText"
          class="ball__number"
          v-text="item.ball[currentLabel].label"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    period: {
      type: String,
      default: '',
      required: false
    },
    list: {
      type: Array,
      default: () => [],
      required: false
    },
    currentLabel: {
      type: String,
      required: true
    },
    lotteryType: {
      type: String,
      required: true
    },
    lotteryCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {
    activeNumList() {
      return this.$store.state.lottery.activeNumList
    },
    activeLiangMianList() {
      return this.$store.state.lottery.activeLiangMianList
    }
  },
  watch: {
    activeNumList(activeNumList) {
      this.setOpacity()
    },
    activeLiangMianList(activeLiangMianList) {
      this.setOpacity()
    }
  },
  created() {
    this.setOpacity()
  },
  methods: {
    setOpacity() {
      this.list.forEach((item) => {
        let isOpacity = false

        if (this.activeNumList.length !== 0) {
          isOpacity = !this.activeNumList.includes(item.ball.hm.label)
        } else if (this.activeLiangMianList.length !== 0) {
          let result = true
          this.activeLiangMianList.forEach((key) => {
            result = result && item.twoSides[key]
          })
          isOpacity = !result
        } else {
          isOpacity = false
        }

        item.isOpacity = isOpacity
      })
    }
  }
}
</script>

<style scoped>
  .image-disable {
    opacity: 0.2;
  }
</style>
